// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"a628c933","635":"c8fa9668","747":"fa0040f3","771":"1019d596","853":"b8ddcc8c","879":"b39fd3f1"}[chunkId] + ".chunk.js";
};